import React from 'react'
import { useHistory } from 'react-router-dom'

export default function withRouterActions(WrappedComponent) {
  return function(props) {
    const history = useHistory()
    const routerPush = React.useCallback(
      url => {
        history.push(url)
      },
      [history]
    )

    const routerReplace = React.useCallback(
      url => {
        history.replace(url)
      },
      [history]
    )

    return (
      <WrappedComponent
        {...props}
        routerPush={routerPush}
        routerReplace={routerReplace}
      />
    )
  }
}
